/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Language_BsInputs */

const en_nav_language_bs = /** @type {(inputs: Nav_Language_BsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bosanski`)
};

const es_nav_language_bs = /** @type {(inputs: Nav_Language_BsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bosanski`)
};

const de_nav_language_bs = /** @type {(inputs: Nav_Language_BsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bosanski`)
};

const zh_nav_language_bs = /** @type {(inputs: Nav_Language_BsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bosanski`)
};

const ar_nav_language_bs = /** @type {(inputs: Nav_Language_BsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bosanski`)
};

const fr_nav_language_bs = /** @type {(inputs: Nav_Language_BsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bosanski`)
};

const vi_nav_language_bs = /** @type {(inputs: Nav_Language_BsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bosanski`)
};

const sw_nav_language_bs = /** @type {(inputs: Nav_Language_BsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bosanski`)
};

const th_nav_language_bs = /** @type {(inputs: Nav_Language_BsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bosanski`)
};

const bs_nav_language_bs = /** @type {(inputs: Nav_Language_BsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bosanski`)
};

const ja_nav_language_bs = /** @type {(inputs: Nav_Language_BsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bosanski`)
};

const ko_nav_language_bs = /** @type {(inputs: Nav_Language_BsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bosanski`)
};

const pt_nav_language_bs = /** @type {(inputs: Nav_Language_BsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bosanski`)
};

const it_nav_language_bs = /** @type {(inputs: Nav_Language_BsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bosanski`)
};

const sv_nav_language_bs = /** @type {(inputs: Nav_Language_BsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bosanski`)
};

const nl_nav_language_bs = /** @type {(inputs: Nav_Language_BsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bosanski`)
};

const da_nav_language_bs = /** @type {(inputs: Nav_Language_BsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bosanski`)
};

const nb_nav_language_bs = /** @type {(inputs: Nav_Language_BsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bosanski`)
};

const fi_nav_language_bs = /** @type {(inputs: Nav_Language_BsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bosanski`)
};

const pl_nav_language_bs = /** @type {(inputs: Nav_Language_BsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bosanski`)
};

const ru_nav_language_bs = /** @type {(inputs: Nav_Language_BsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bosanski`)
};

const tr_nav_language_bs = /** @type {(inputs: Nav_Language_BsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bosanski`)
};

const hi_nav_language_bs = /** @type {(inputs: Nav_Language_BsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bosanski`)
};

const id_nav_language_bs = /** @type {(inputs: Nav_Language_BsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bosanski`)
};

const ms_nav_language_bs = /** @type {(inputs: Nav_Language_BsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bosanski`)
};

const cs_nav_language_bs = /** @type {(inputs: Nav_Language_BsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bosanski`)
};

const el_nav_language_bs = /** @type {(inputs: Nav_Language_BsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bosanski`)
};

const he_nav_language_bs = /** @type {(inputs: Nav_Language_BsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bosanski`)
};

const af_nav_language_bs = /** @type {(inputs: Nav_Language_BsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bosanski`)
};

const hu_nav_language_bs = /** @type {(inputs: Nav_Language_BsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bosanski`)
};

/**
* | output |
* | --- |
* | "Bosanski" |
*
* @param {Nav_Language_BsInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const nav_language_bs = /** @type {((inputs?: Nav_Language_BsInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Language_BsInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_nav_language_bs(inputs)
	if (locale === "de") return de_nav_language_bs(inputs)
	if (locale === "zh") return zh_nav_language_bs(inputs)
	if (locale === "ar") return ar_nav_language_bs(inputs)
	if (locale === "fr") return fr_nav_language_bs(inputs)
	if (locale === "vi") return vi_nav_language_bs(inputs)
	if (locale === "sw") return sw_nav_language_bs(inputs)
	if (locale === "th") return th_nav_language_bs(inputs)
	if (locale === "bs") return bs_nav_language_bs(inputs)
	if (locale === "ja") return ja_nav_language_bs(inputs)
	if (locale === "ko") return ko_nav_language_bs(inputs)
	if (locale === "pt") return pt_nav_language_bs(inputs)
	if (locale === "it") return it_nav_language_bs(inputs)
	if (locale === "sv") return sv_nav_language_bs(inputs)
	if (locale === "nl") return nl_nav_language_bs(inputs)
	if (locale === "da") return da_nav_language_bs(inputs)
	if (locale === "nb") return nb_nav_language_bs(inputs)
	if (locale === "fi") return fi_nav_language_bs(inputs)
	if (locale === "pl") return pl_nav_language_bs(inputs)
	if (locale === "ru") return ru_nav_language_bs(inputs)
	if (locale === "tr") return tr_nav_language_bs(inputs)
	if (locale === "hi") return hi_nav_language_bs(inputs)
	if (locale === "id") return id_nav_language_bs(inputs)
	if (locale === "ms") return ms_nav_language_bs(inputs)
	if (locale === "cs") return cs_nav_language_bs(inputs)
	if (locale === "el") return el_nav_language_bs(inputs)
	if (locale === "he") return he_nav_language_bs(inputs)
	if (locale === "af") return af_nav_language_bs(inputs)
	if (locale === "hu") return hu_nav_language_bs(inputs)
	return en_nav_language_bs(inputs)
});